import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import {
  getInvoiceConfigurationsByApp,
  createInvoiceAppConfiguration,
  getInvoiceAppConfigurationByAppAndId
} from '../../services/apiApps'
import { v4 as uuidv4 } from 'uuid'
import { get } from 'lodash'
import InvoiceView from './InvoiceView'

import { showLoading, hideLoading, checkExpiration } from 'utils/functions'

let _isMounted = false

const newAppValidations = {
  service: 'ariba',
  env: '',
  type: 'Test',
  enabled: true,
  displayMode: 'create',
  parameters: {
    region: '',
    siteUrl: ''
  }
}

async function getAppList(props, callback = () => {}, selectedApp = undefined) {
  let response = await getInvoiceConfigurationsByApp()
  const data = checkExpiration(props.enabledApps['invoiceAI'])
  props.setExpirationData(data)
  if (response && response.success) {
    if (_isMounted) {
      if (response.data && response.data.length > 0) {
        props.setAppList(response.data)
        if (response.data.length !== 0) {
          // get app details
          if (!selectedApp) selectedApp = response.data[0].env
          await getAppDetails(props, selectedApp)
        }
        props.setPageIsLoading(false)
      }
    }
  }
  callback(props.setPageIsLoading)
}

export async function saveAppdetails(props, appDetails, refresh = true) {
  //Save complete object
  if (appDetails.data && appDetails.data.data) {
    let validationDetails = appDetails.data.data
    validationDetails.displayMode = 'edit'
    if (_isMounted) {
      props.setValidationsForm(validationDetails)
      props.setFormIsLoading(false)
      if (refresh) props.setRefresh(!props.refresh)
    }
  }
}

export async function getAppDetails(props, id) {
  props.setFormIsLoading(true)
  props.setSelectedAppId(id)
  props.setDisplayMode('edit')
  let appDetails = await getInvoiceAppConfigurationByAppAndId(id)
  if (appDetails && appDetails.success) {
    processUpdateParameters(appDetails.data?.data?.parameters, appDetails.data?.data)
    await saveAppdetails(props, appDetails)
  } else {
    let message = appDetails.message
    if (!message) {
      message = 'Something went wrong, please try again later.'
    }
    props.setValidationMessage(message)
    props.setCreateError(true)
    props.setFormIsLoading(false)
  }
}

function processUpdateParameters(parameters, configuration) {
  if (parameters && configuration?.params) {
    const keys = Object.keys(parameters)
    for (let index = 0; index < keys.length; index++) {
      if (typeof parameters[keys[index]] === 'object' && !parameters[keys[index]]?.value) {
        if (keys[index] === 'microsoftGraphApi' && parameters[keys[index]].type === 'msAccount') {
          const path = parameters[keys[index]]?.code?.path.split('.') ?? []
          path[path.length - 1] = 'email'
          const emailPath = path.join('.')
          let email = get(configuration, emailPath)

          path[path.length - 1] = 'accountId'
          const accountPath = path.join('.')
          let accountId = get(configuration, accountPath)

          if (accountId !== undefined) {
            parameters[keys[index]].accountId = accountId
          }
          if (email !== undefined) {
            parameters[keys[index]].email = email
          }
        }
        processUpdateParameters(parameters[keys[index]], configuration)
      }

      if (parameters[keys[index]]?.path) {
        const value = get(configuration, parameters[keys[index]]?.path)

        if (value !== undefined && parameters[keys[index]]?.value !== undefined) {
          parameters[keys[index]].value = value
        }
      }
    }
  }
  return parameters
}

async function onSubmit(props, event) {
  let successMessage
  let response
  let env
  if (props.displayMode === 'create') {
    let validations = event.validations
    validations.appName = validations.env
    delete validations.mapping
    validations.env = uuidv4()
    validations.appType = 'invoiceAI'
    response = await createInvoiceAppConfiguration('invoiceAI', validations)
    successMessage = 'App created successfully'
    env = validations.env
  }

  if (response && response.success && _isMounted) {
    props.setValidationMessage(successMessage)
    props.setSubmitSuccess(true)

    if (props.displayMode === 'create') {
      await getAppList(props, async callback => {
        await appChanged(props, env)
        hideLoading(callback)
      })
    } else hideLoading(props.setPageIsLoading)

    setTimeout(function() {
      if (_isMounted) {
        props.setSubmitSuccess(false)
      }
    }, 5000)
    return true
  } else {
    hideLoading(props.setPageIsLoading)
    // Show error message
    if (response) {
      let message = response.message
      if (!message) {
        if (response.errors && typeof response.errors === 'string') {
          message = response.errors
        } else if (
          response.errors &&
          typeof response.errors === 'object' &&
          response.errors.length > 0
        ) {
          message = ''
          response.errors.forEach(error => {
            message += ' ' + error.msg
          })
        } else message = 'Something went wrong, please try again later.'
      }
      props.setValidationMessage(message)
      props.setCreateError(true)
    }
    return false
  }
}

async function appChanged(props, id) {
  await getAppDetails(props, id)
  hideLoading(props.setPageIsLoading)
}

function onNewCreateIsCalled(props) {
  props.setFormIsLoading(true)
  props.setDisplayMode('create')
  props.setSelectedAppId(null)

  props.setValidationsForm({ ...newAppValidations })

  setTimeout(function() {
    props.setFormIsLoading(false)
  }, 500)
}

export default compose(
  connect(
    state => ({
      isAuthenticated: state.login.isAuthenticated,
      name: state.login.name,
      enabledApps: state.app.enabledApps
    }),
    {}
  ),
  withState('appList', 'setAppList', []),
  withState('refresh', 'setRefresh', false),
  withState('selectedAppId', 'setSelectedAppId', null),
  withState('displayMode', 'setDisplayMode', 'create'),
  withState('validationsForm', 'setValidationsForm', { ...newAppValidations }),
  withState('formIsLoading', 'setFormIsLoading', false),
  withState('submitSuccess', 'setSubmitSuccess', false),
  withState('createError', 'setCreateError', false),
  withState('validationMessage', 'setValidationMessage', ''),
  withState('pageIsLoading', 'setPageIsLoading', true),
  withState('expirationData', 'setExpirationData', {}),
  withHandlers({
    onAppChanged: props => id => {
      showLoading(props.setPageIsLoading)
      appChanged(props, id)
    },
    onCreateButton: props => () => {
      if (props.displayMode !== 'create') {
        onNewCreateIsCalled(props)
      }
    },
    onAppSaved: props => async event => {
      props.setPageIsLoading(true)
      showLoading(props.setPageIsLoading)
      return onSubmit(props, event)
    }
  }),
  lifecycle({
    componentDidMount() {
      showLoading(this.props.setPageIsLoading)
      _isMounted = true
      this.props.setPageIsLoading(true)
      getAppList(this.props, hideLoading)
    }
  })
)(InvoiceView)
